<avi-confirmation
    headerText="{{ l10nKeys.title | vtranslate }}"
    (onClose)="handleClose()"
>
    <avi-confirmation_modal-content>
        <div> {{ message }} </div>
    </avi-confirmation_modal-content>
</avi-confirmation>
